import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { HandCoins, Car, Check, ShieldCheck, TrendingUp, Users, ArrowRight } from 'lucide-react'

const inputCls = 'w-full rounded-xl border border-slate-300 px-4 py-2.5 text-base outline-none focus:border-brand-600 sm:text-sm'

export default function Investir() {
  const [aba, setAba] = useState('dinheiro')
  const [enviado, setEnviado] = useState(null) // 'dinheiro' | 'carro'
  const navigate = useNavigate()

  return (
    <main>
      {/* Hero investidor */}
      <section className="bg-brand-900">
        <div className="mx-auto max-w-6xl px-4 py-10 text-center md:py-16">
          <span className="rounded-full bg-white/10 px-3 py-1 text-xs font-semibold text-brand-100">Para investidores</span>
          <h1 className="font-display mx-auto mt-4 max-w-2xl text-3xl font-extrabold tracking-tight text-white md:text-4xl">
            Seu dinheiro (ou seu carro) trabalhando com a Sim
          </h1>
          <p className="mx-auto mt-4 max-w-2xl text-brand-100/90">
            A Sim opera um modelo de aluguel com transferência de propriedade e cuida de tudo: seguro, manutenção, análise e cobrança. Você entra com o carro ou com o capital — a gente faz o resto.
          </p>
          <div className="mx-auto mt-6 grid max-w-3xl gap-3 text-left sm:grid-cols-3 md:mt-8 md:gap-4">
            {[
              { icon: ShieldCheck, t: 'Operação cuidada', d: 'Frota segurada e com manutenção em dia.' },
              { icon: TrendingUp, t: 'Modelo já rodando', d: 'A Sim já opera com frota própria hoje.' },
              { icon: Users, t: 'Análise humana', d: 'Compradores avaliados um a um pela equipe.' },
            ].map(({ icon: Icon, t, d }) => (
              <div key={t} className="rounded-2xl bg-white/10 p-4">
                <Icon size={20} className="text-brand-100" />
                <div className="mt-2 text-sm font-bold text-white">{t}</div>
                <div className="mt-0.5 text-xs text-brand-100/80">{d}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Interesse rápido: só nome + WhatsApp */}
      <section className="mx-auto max-w-2xl px-4 py-8 md:py-12">
        <div className="flex rounded-full border border-slate-200 bg-white p-1 shadow-sm">
          {[
            { id: 'dinheiro', label: 'Investir dinheiro', curto: 'Dinheiro', icon: HandCoins },
            { id: 'carro', label: 'Consignar meu carro', curto: 'Meu carro', icon: Car },
          ].map(({ id, label, curto, icon: Icon }) => (
            <button
              key={id}
              onClick={() => { setAba(id); setEnviado(null) }}
              className={`flex flex-1 items-center justify-center gap-2 rounded-full py-2.5 text-sm font-semibold transition ${
                aba === id ? 'bg-brand-600 text-white shadow' : 'text-slate-500 hover:text-slate-800'
              }`}
            >
              <Icon size={16} /> <span className="hidden sm:inline">{label}</span><span className="sm:hidden">{curto}</span>
            </button>
          ))}
        </div>

        <div className="mt-6">
          {enviado === aba ? (
            <div className="rounded-2xl border border-slate-200 bg-white p-6 text-center shadow-sm md:p-8">
              <div className="mx-auto inline-flex rounded-full bg-brand-50 p-4 text-brand-600"><Check size={32} /></div>
              <h3 className="font-display mt-4 text-xl font-bold">Recebemos seu interesse!</h3>
              <p className="mx-auto mt-2 max-w-sm text-sm text-slate-500">
                Nossa equipe vai te chamar no WhatsApp. Quer acelerar a conversa? Complete seu cadastro agora — leva uns 3 minutos.
              </p>
              <button
                onClick={() => navigate(`/investir/dados?tipo=${aba}`)}
                className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-xl bg-brand-600 py-3 font-semibold text-white transition hover:bg-brand-700 active:scale-[0.98]"
              >
                Completar cadastro agora <ArrowRight size={16} />
              </button>
              <button onClick={() => setEnviado(null)} className="mt-2 w-full rounded-xl py-2.5 text-sm font-medium text-slate-500 hover:bg-slate-50">
                Deixar para depois
              </button>
            </div>
          ) : (
            <form
              className="space-y-3 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm md:p-6"
              onSubmit={(e) => { e.preventDefault(); setEnviado(aba) }}
            >
              <div className="font-display text-lg font-bold">
                {aba === 'dinheiro' ? 'Quero investir dinheiro' : 'Quero consignar meu carro'}
              </div>
              <p className="text-sm text-slate-500">Só o básico por enquanto — o resto você completa depois, no seu tempo.</p>
              <input required placeholder="Seu nome" className={inputCls} />
              <input required placeholder="WhatsApp (DDD + número)" className={inputCls} />
              <button className="w-full rounded-xl bg-brand-600 py-3 font-semibold text-white transition hover:bg-brand-700 active:scale-[0.98]">
                {aba === 'dinheiro' ? 'Quero investir' : 'Quero consignar'}
              </button>
              <p className="text-center text-[11px] text-slate-400">
                Registro de interesse — sem movimentação financeira pela plataforma (LGPD).
              </p>
            </form>
          )}
        </div>
      </section>
    </main>
  )
}
